import {Injectable} from 'ng-metadata/core';
import {CitationTrailsService} from '../search/citationTrails/citationTrails.service';
import {isCitationTrailsEnabled} from '../appConfig/appConfigForward';
import {PrimoResponse as PrimoResponseExtras} from "./dataStructures/PrimoResponses/extras.interface";
import {PrimoResponse} from "./dataStructures/PrimoResponses/doc.interfcae";

const _has = require('lodash/has');

@Injectable()
export class RecordUtil{

	constructor(private citationTrailsService : CitationTrailsService) {
	}

	public getCitationTrails(doc: PrimoResponse.IExtendedDoc) : PrimoResponseExtras.Extras.ICitationTrails{
		return _has(doc, 'extras.citationTrails') ? doc.extras.citationTrails : null;
	}

	public hasCitationTrails(item: PrimoResponse.IExtendedDoc):boolean{
		let ctInfo: PrimoResponseExtras.Extras.ICitationTrails = this.getCitationTrails(item);
		return (ctInfo && ((ctInfo.citing && ctInfo.citing.length >0 ) || (ctInfo.citedby && ctInfo.citedby.length > 0)));
	}

	/**
	 * Add Record's extra data (Citation trails, snippets etc.)
	 * If not added yet.
	 * @param doc
	 */
	public loadRecordsExtras(docs: PrimoResponse.IDoc[]){

		if(isCitationTrailsEnabled()) {
			return this.citationTrailsService.updateCitationsList(
				docs.filter(doc => !_has(doc, 'extras.citationTrails'))
			);
		}
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/RecordUtil.service.ts